import { render, staticRenderFns } from "./create-item.vue?vue&type=template&id=6ad8c4bf"
import script from "./create-item.vue?vue&type=script&lang=js"
export * from "./create-item.vue?vue&type=script&lang=js"
import style0 from "./create-item.vue?vue&type=style&index=0&id=6ad8c4bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports